(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRec(root) {
      var url = root.getAttribute('data-rec-url');
      if (!url || root.dataset.recDone) return;
      root.dataset.recDone = '1';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newTrack = doc.querySelector('[data-carousel-track]');
          var track = root.querySelector('[data-carousel-track]');
          if (newTrack && track) { track.innerHTML = newTrack.innerHTML; }
          // sem recomendações: esconde a seção pra não deixar um vazio
          if (track && track.children.length === 0) {
            var section = root.closest('.shopify-section');
            if (section) section.hidden = true; else root.hidden = true;
          }
        })
        .catch(function () {});
    }
    function initAll() { document.querySelectorAll('nanovit-carousel[data-rec-url]').forEach(initRec); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-cta-institucional"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('.cta-hotspot.is-open').forEach(function (h) {
        if (h !== except) h.classList.remove('is-open');
      });
    }

    function addToCart(variantId, btn) {
      if (!variantId || btn.disabled) return;
      btn.disabled = true;
      var routes = (window.Shopify && window.Shopify.routes) || {};
      var addUrl = routes.cart_add_url || '/cart/add';
      var cartUrl = routes.cart_url || '/cart';
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { sectionIds.push(el.dataset.sectionId); });
      var label = btn.textContent;
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { btn.disabled = false; return; }
          btn.classList.add('is-added');
          btn.textContent = 'Adicionado ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; btn.disabled = false; }, 1600);
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'nv-hotspot', data: { source: 'nv-hotspot', sections: data.sections, itemCount: cart.item_count } }
              }));
              var drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function') drawer.open();
            });
        })
        .catch(function () { btn.disabled = false; });
    }

    function bindHover() {
      if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
      document.querySelectorAll('[data-hotspot]').forEach(function (hs) {
        if (hs.dataset.hoverBound) return;
        hs.dataset.hoverBound = '1';
        hs.addEventListener('pointerenter', function () { closeAll(hs); hs.classList.add('is-open'); });
        hs.addEventListener('pointerleave', function () { hs.classList.remove('is-open'); });
      });
    }

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-hotspot-add]');
      if (add) { addToCart(add.getAttribute('data-variant-id'), add); return; }
      var toggle = e.target.closest('[data-hotspot-toggle]');
      if (toggle) {
        e.stopPropagation();
        var hs = toggle.closest('[data-hotspot]');
        var wasOpen = hs.classList.contains('is-open');
        closeAll();
        if (!wasOpen) hs.classList.add('is-open');
        return;
      }
      if (!e.target.closest('[data-hotspot-card]')) closeAll();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bindHover); } else { bindHover(); }
    document.addEventListener('shopify:section:load', bindHover);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-header"] && !Shopify.designMode) return;
  try {
    
  function nvInitHeaderSearch() {
    document.querySelectorAll('.nv-search:not([data-nv-bound])').forEach(function (root) {
      root.setAttribute('data-nv-bound', '1');
      var input = root.querySelector('.search-input');
      if (!input) return;
      function openSearch() { root.classList.add('nv-search--open'); }
      /* Open only on real interaction (click / typing), never on bare focus —
         both the theme editor (switching pages) and AJAX navigation can refocus
         the input, which would otherwise pop the dropdown open on every screen
         change. pointerdown covers the click; input covers typing. */
      input.addEventListener('pointerdown', openSearch);
      input.addEventListener('input', openSearch);

      /* Drop any focus the field grabs on initial load (the predictive-search
         component / browser focus-restore can land on it), so the site doesn't
         open with the search active and the mobile keyboard up. Stops as soon
         as the user actually interacts with the page. */
      var userActed = false;
      ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
        window.addEventListener(ev, function () { userActed = true; }, { capture: true, once: true });
      });
      function dropInitialFocus() {
        if (!userActed && document.activeElement === input) input.blur();
      }
      dropInitialFocus();
      requestAnimationFrame(dropInitialFocus);
      setTimeout(dropInitialFocus, 200);
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) root.classList.remove('nv-search--open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { root.classList.remove('nv-search--open'); input.blur(); }
      });
    });
  }
  nvInitHeaderSearch();
  document.addEventListener('shopify:section:load', nvInitHeaderSearch);

  // Mega-menu hover: open after a 1s hold, close 300ms after leaving (so the
  // mouse has time to travel from the nav item down to the panel).
  // Busca os cards do mega menu na primeira vez que o mouse chega no item.
  // O track vem vazio do servidor (ver snippets/nanovit-mega-panel.liquid);
  // aqui pedimos a seção 'nanovit-mega-products' no contexto da coleção.
  function nvHydrateMega(item) {
    var track = item.querySelector('[data-mega-track][data-mega-src]');
    if (!track || track.dataset.megaLoaded) return;
    track.dataset.megaLoaded = '1'; // marca antes: evita 2 fetches em hover rápido
    fetch(track.dataset.megaSrc, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        // a resposta vem embrulhada na div da seção; usamos só o conteúdo
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var host = doc.querySelector('.shopify-section') || doc.body;
        track.innerHTML = host.innerHTML.trim();
        // as setas do carrossel só aparecem quando há overflow.
        // Evento próprio em vez de sintetizar 'resize': aquilo acordava TODOS os
        // listeners de resize da página (vários fazem getBoundingClientRect) só
        // para recalcular duas setas.
        window.dispatchEvent(new CustomEvent('nv:mega-loaded'));
      })
      .catch(function () {
        // falhou: libera para tentar de novo no próximo hover
        delete track.dataset.megaLoaded;
      });
  }

  function nvInitMegaMenu() {
    document.querySelectorAll('.nv-nav-item--mega:not([data-nv-mega-bound])').forEach(function (item) {
      item.setAttribute('data-nv-mega-bound', '1');
      var openTimer = null;
      var closeTimer = null;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        nvHydrateMega(item); // começa a busca já no mouseenter, antes do hold de 200ms
        if (item.classList.contains('nv-nav-item--open')) return;
        openTimer = setTimeout(function () { item.classList.add('nv-nav-item--open'); }, 200);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { item.classList.remove('nv-nav-item--open'); }, 300);
      });
      // teclado: foco no item também carrega (o CSS abre com :focus-within)
      item.addEventListener('focusin', function () { nvHydrateMega(item); });
    });

    // Prefetch por intenção: o mouse chegar na barra já dispara a busca de
    // todos os painéis. A seção responde em ~0,5s e o painel só abre 200ms
    // após o hover no item, então sem isso sobrava um intervalo de painel
    // vazio. Continua sob demanda: nada é buscado até o usuário ir ao menu.
    var nav = document.querySelector('.nv-header__nav');
    if (nav && !nav.dataset.nvMegaPrefetch) {
      nav.dataset.nvMegaPrefetch = '1';
      nav.addEventListener('mouseenter', function () {
        nav.querySelectorAll('.nv-nav-item--mega').forEach(nvHydrateMega);
      }, { once: true });
    }
  }
  nvInitMegaMenu();
  document.addEventListener('shopify:section:load', nvInitMegaMenu);

  // Measure everything above the header inside #header-group (the benefits
  // marquee) and expose it as --nv-marquee-h, so the sticky group offsets it
  // off-screen — only the header stays pinned, the marquee scrolls away.
  function nvStickyOffset() {
    var group = document.getElementById('header-group');
    if (!group) return;
    var card = group.querySelector('.nv-header');
    var headerSection = card ? card.closest('.shopify-section') : null;
    if (!headerSection) return;
    // Offset the group up ONLY by the marquee strip above the header, and only
    // if it actually exists. Previously this summed every sibling above the
    // header, so with no marquee (or any other element above) the header was
    // pushed off-screen. Now we count a previous sibling only when it IS the
    // marquee (by class) or contains it; 0 when there's no marquee.
    var h = 0;
    var sib = headerSection.previousElementSibling;
    while (sib) {
      var isMarquee = sib.classList.contains('nv-marquee-section') ||
        (sib.querySelector && sib.querySelector('.nv-marquee-section, .marquee'));
      if (isMarquee) { h += sib.getBoundingClientRect().height; }
      sib = sib.previousElementSibling;
    }
    group.style.setProperty('--nv-marquee-h', h + 'px');
  }
  nvStickyOffset();
  window.addEventListener('load', nvStickyOffset);
  // Debounce: nvStickyOffset chama getBoundingClientRect (reflow forçado) e o
  // resize dispara a cada show/hide da barra de URL e na abertura do teclado no
  // mobile — justamente durante a busca. O mesmo arquivo já usa 150ms na linha
  // do mega-menu; aqui estava sem nada.
  var nvStickyT;
  window.addEventListener('resize', function () {
    clearTimeout(nvStickyT);
    nvStickyT = setTimeout(nvStickyOffset, 150);
  });
  document.addEventListener('shopify:section:load', nvStickyOffset);

  // Priority nav (desktop >= 1100px): mede a barra e os itens; o que não couber
  // sai para um dropdown "Ver tudo". Abaixo de 1100px o scroll lateral nativo
  // cuida (não mexe). Mega-menus que transbordam viram link simples no dropdown.
  function nvInitPriorityNav() {
    document.querySelectorAll('.nv-header__nav:not([data-nv-prio-bound])').forEach(function (nav) {
      var more = nav.querySelector('[data-nv-more]');
      if (!more) return;
      nav.setAttribute('data-nv-prio-bound', '1');
      var btn = more.querySelector('.nv-nav-more__btn');
      var panel = more.querySelector('.nv-nav-more__panel');

      function items() {
        return Array.prototype.filter.call(nav.children, function (c) {
          return c !== more && c.classList.contains('nv-nav-item');
        });
      }
      function addToPanel(item) {
        var a = item.querySelector('a');
        if (!a) return;
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.href = a.getAttribute('href') || '#';
        link.className = 'nv-nav-more__item';
        link.textContent = (a.textContent || '').trim();
        if (a.classList.contains('nav-strip__link--active') || a.classList.contains('nav-strip__pill--active')) {
          link.classList.add('nv-nav-more__item--active');
        }
        li.appendChild(link);
        panel.appendChild(li);
      }
      function close() {
        more.classList.remove('nv-nav-more--open');
        btn.setAttribute('aria-expanded', 'false');
      }
      function reset() {
        items().forEach(function (it) { it.hidden = false; });
        panel.innerHTML = '';
        more.hidden = true;
        close();
      }
      function layout() {
        if (window.innerWidth <= 1100) { nav.classList.remove('nv-nav--priority'); reset(); return; }
        nav.classList.add('nv-nav--priority');
        reset();
        more.hidden = false; // visível para medir a largura do botão
        var navRect = nav.getBoundingClientRect();
        var cs = getComputedStyle(nav);
        var padRight = parseFloat(cs.paddingRight) || 0;
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        var limit = navRect.right - padRight - more.offsetWidth - gap - 4;
        var overflow = false;
        items().forEach(function (it) {
          if (overflow) { addToPanel(it); it.hidden = true; return; }
          if (it.getBoundingClientRect().right > limit) {
            overflow = true; addToPanel(it); it.hidden = true;
          }
        });
        more.hidden = !overflow;
        if (!overflow) close();
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = more.classList.toggle('nv-nav-more--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) { if (!more.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      layout();
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(layout, 150); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    });
  }
  nvInitPriorityNav();
  document.addEventListener('shopify:section:load', nvInitPriorityNav);

  // Mega-menu carousels: arrows scroll the horizontal track; arrows hide when
  // everything already fits.
  function nvInitMegaCarousel() {
    document.querySelectorAll('[data-mega-track]:not([data-nv-cbound])').forEach(function (track) {
      track.setAttribute('data-nv-cbound', '1');
      var carousel = track.closest('.nv-mega__carousel');
      if (!carousel) return;
      var prev = carousel.querySelector('[data-mega-prev]');
      var next = carousel.querySelector('[data-mega-next]');
      function step() { var f = track.firstElementChild; return f ? f.getBoundingClientRect().width + 16 : 200; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      function update() {
        var over = track.scrollWidth > track.clientWidth + 4;
        if (prev) prev.hidden = !over;
        if (next) next.hidden = !over;
      }
      update();
      var megaT;
      window.addEventListener('resize', function () {
        clearTimeout(megaT);
        megaT = setTimeout(update, 150);
      });
      // carrossel recém-hidratado por fetch: recalcula na hora, sem debounce
      window.addEventListener('nv:mega-loaded', update);
      var item = carousel.closest('.nv-nav-item');
      if (item) item.addEventListener('mouseenter', function () { setTimeout(update, 60); });
    });
  }
  nvInitMegaCarousel();
  document.addEventListener('shopify:section:load', nvInitMegaCarousel);

  function nvInitMobileMenu() {
    var menu = document.getElementById('nv-mmenu');
    if (!menu || menu.dataset.nvBound) return;
    menu.dataset.nvBound = '1';
    var openBtn = document.querySelector('[data-mmenu-open]');
    function setOpen(open) {
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nv-mmenu-open', open);
      if (open) {
        var c = menu.querySelector('.nv-mmenu__close');
        if (c && c.focus) c.focus();
      } else if (openBtn && openBtn.focus) {
        openBtn.focus();
      }
    }
    if (openBtn) openBtn.addEventListener('click', function () {
      // busca os cards das vitrines no 1º open (nvHydrateMega é compartilhado
      // com o mega menu do desktop e ignora tracks já carregados)
      menu.querySelectorAll('[data-mega-track][data-mega-src]').forEach(function (t) {
        nvHydrateMega(t.closest('.nv-mmenu__group') || t.parentNode);
      });
      setOpen(true);
    });
    menu.querySelectorAll('[data-mmenu-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    menu.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    menu.querySelectorAll('[data-mmenu-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var sub = btn.nextElementSibling;
        if (sub) { if (expanded) { sub.setAttribute('hidden', ''); } else { sub.removeAttribute('hidden'); } }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('aria-hidden') === 'false') setOpen(false);
    });
  }
  nvInitMobileMenu();
  document.addEventListener('shopify:section:load', nvInitMobileMenu);

  /* own add-to-cart: SVG+text button. Single variant adds directly and opens the
     cart; multi opens the informative pop-up (#nv-vmodal) to pick the variant.
     Product data is fetched via /products/{handle}.js (no heavy attribute JSON).
     preventDefault + stopPropagation so the click never navigates to the product. */
  function nvInitCrossSell() {
    if (window.nvXsellBound) return;
    window.nvXsellBound = true;
    var R = (typeof routes !== 'undefined' && routes) || {};
    var addUrl = R.cart_add_url || '/cart/add';
    var cartUrl = R.cart_url || '/cart';
    var modal = document.getElementById('nv-vmodal');
    var selectedId = null, sourceBtn = null;

    function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    function openCart() { var d = document.querySelector('cart-drawer-component'); if (d && typeof d.open === 'function') d.open(); }

    function doAdd(variantId, btn, fromModal) {
      if (!variantId) return;
      if (btn) btn.disabled = true;
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { sectionIds.push(el.dataset.sectionId); });
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { if (btn) btn.disabled = false; return; }
          if (btn) btn.disabled = false;
          if (fromModal) closeModal();
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'nv-xsell', data: { source: 'nv-xsell', sections: data.sections, itemCount: cart.item_count } }
              }));
              openCart();
            });
        })
        .catch(function () { if (btn) btn.disabled = false; });
    }

    function cleanupModal() { document.body.classList.remove('nv-vmodal-open'); selectedId = null; }
    function closeModal() {
      if (!modal) return;
      if (modal.open && modal.close) modal.close(); else { modal.hidden = true; cleanupModal(); }
    }
    if (modal && modal.addEventListener && !modal.dataset.nvBound) {
      modal.dataset.nvBound = '1';
      modal.addEventListener('close', cleanupModal); /* native Esc + .close() */
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); }); /* backdrop */
    }

    function openModal(btn) {
      var handle = btn.getAttribute('data-handle');
      if (!modal || !handle) { doAdd(btn.getAttribute('data-variant-id'), btn); return; }
      selectedId = null;
      var img = modal.querySelector('[data-vmodal-img]');
      var title = modal.querySelector('[data-vmodal-title]');
      var tags = modal.querySelector('[data-vmodal-tags]');
      var opts = modal.querySelector('[data-vmodal-options]');
      var addBtn = modal.querySelector('[data-vmodal-add]');
      if (title) title.textContent = btn.getAttribute('data-title') || '';
      if (img) { img.removeAttribute('src'); img.classList.add('is-loading'); }
      if (addBtn) addBtn.disabled = true;
      if (tags) {
        tags.innerHTML = '';
        (btn.getAttribute('data-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean).slice(0, 4).forEach(function (t, i) {
          var s = document.createElement('span'); s.className = 'nv-vmodal__tag nv-tag--' + (i % 10); s.textContent = t; tags.appendChild(s);
        });
      }
      /* skeleton com a altura real das linhas de opção: o dialog abre já no
         tamanho final típico (3 variantes) e não pula quando os dados chegam */
      if (opts) {
        var skel = '';
        for (var si = 0; si < 3; si++) {
          skel += '<div class="nv-vmodal__opt nv-vmodal__opt--skel" aria-hidden="true"><span class="nv-skel-bar nv-skel-bar--name"></span><span class="nv-skel-bar nv-skel-bar--price"></span></div>';
        }
        opts.innerHTML = skel;
      }
      if (modal.showModal) { try { if (!modal.open) modal.showModal(); } catch (e) { modal.hidden = false; } } else { modal.hidden = false; }
      document.body.classList.add('nv-vmodal-open');
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (img) {
            if (p.featured_image) {
              img.onload = function () { img.classList.remove('is-loading'); };
              img.src = p.featured_image;
              img.alt = p.title;
            } else {
              img.classList.remove('is-loading');
            }
          }
          if (title && !title.textContent) title.textContent = p.title;
          if (opts) {
            opts.innerHTML = '';
            p.variants.forEach(function (vr) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'nv-vmodal__opt';
              if (!vr.available) { b.disabled = true; b.classList.add('is-out'); }
              var t = document.createElement('span'); t.className = 'nv-vmodal__opt-title'; t.textContent = vr.title;
              var pr = document.createElement('span'); pr.className = 'nv-vmodal__opt-price';
              if (vr.compare_at_price && vr.compare_at_price > vr.price) {
                var sx = document.createElement('s'); sx.textContent = money(vr.compare_at_price); pr.appendChild(sx); pr.appendChild(document.createTextNode(' '));
              }
              pr.appendChild(document.createTextNode(money(vr.price)));
              b.appendChild(t); b.appendChild(pr);
              b.addEventListener('click', function () {
                selectedId = vr.id;
                opts.querySelectorAll('.nv-vmodal__opt').forEach(function (x) { x.classList.remove('is-sel'); });
                b.classList.add('is-sel');
                if (addBtn) addBtn.disabled = false;
              });
              opts.appendChild(b);
            });
          }
        })
        .catch(function () {
          if (img) img.classList.remove('is-loading');
          if (opts) opts.innerHTML = '<span class="nv-vmodal__loading">Não foi possível carregar.</span>';
        });
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-xsell-prev], [data-xsell-next]');
      if (arrow) {
        e.preventDefault();
        var xs = arrow.closest('.nv-xsell');
        var tr = xs && xs.querySelector('.nv-xsell__track');
        if (tr) {
          var fc = tr.querySelector('.nv-card');
          var step = fc ? (fc.getBoundingClientRect().width + 16) : Math.round(tr.clientWidth * 0.8);
          tr.scrollBy({ left: arrow.hasAttribute('data-xsell-next') ? step : -step, behavior: 'smooth' });
        }
        return;
      }
      var card = e.target.closest('[data-xsell-add]');
      if (card && !card.disabled) {
        e.preventDefault(); e.stopPropagation();
        if (card.getAttribute('data-multi') === '1') { sourceBtn = card; openModal(card); }
        else { doAdd(card.getAttribute('data-variant-id'), card); }
        return;
      }
      if (e.target.closest('[data-vmodal-close]')) { closeModal(); return; }
      var conf = e.target.closest('[data-vmodal-add]');
      if (conf && selectedId) { doAdd(selectedId, conf, true); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

    /* kits por variação no carrinho: o dropdown [data-nv-cart-variant] troca a
       variante da linha (eixo dos potes). O Shopify não tem endpoint de swap,
       mas /cart/update aceita um mapa variante->quantidade, então zerar a antiga
       e somar na nova cabe numa ÚNICA mutação.

       O fluxo anterior (add + change em sequência) NÃO era atômico: o add já
       tinha somado a variante nova quando o change falhava (rede, 429 do
       Shopify, estoque) e a linha antiga ficava no carrinho. Resultado: duas
       linhas visíveis com a quantidade já fundida — o bug relatado. Como agora
       só existe uma mutação, ou tudo acontece ou nada acontece, e o catch que
       devolve o dropdown ao valor antigo passa a ser sempre verdadeiro.

       Mesclar é intencional: trocar para uma variante que já está no carrinho
       soma as quantidades numa linha só. Listener delegado no document, então
       sobrevive aos re-renders do drawer. */
    var updateUrl = R.cart_update_url || '/cart/update';
    var cartUrl = R.cart_url || '/cart';
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-nv-cart-variant]');
      if (!sel) return;
      var current = sel.getAttribute('data-current');
      var newId = sel.value;
      if (!newId || newId === current) return;
      var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
      var sectionIds = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { sectionIds.push(el.dataset.sectionId); });
      sel.disabled = true;

      /* lê o estado fresco só para saber quanto a variante de destino já tem
         (o GET não muda nada; se ele falhar, o carrinho segue intacto) */
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var destino = 0;
          (cart.items || []).forEach(function (it) {
            if (String(it.variant_id) === String(newId)) destino += it.quantity;
          });
          var updates = {};
          updates[current] = 0;
          updates[newId] = destino + qty;
          return fetch(updateUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates, sections: sectionIds.join(','), sections_url: window.location.pathname })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.status) throw cart;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'nv-cart-kit', data: { source: 'nv-cart-kit', sections: cart.sections, itemCount: cart.item_count } }
          }));
        })
        .catch(function () {
          sel.disabled = false;
          sel.value = current;
        });
    });
  }
  nvInitCrossSell();

  /* cross-sell "compre junto": load Shopify product recommendations into the
     placeholder (recommendations mode). The add-to-cart itself is handled by the
     nv-product-card's quick-add. Re-runs on cart:update (the cart re-renders the
     placeholder, fresh and unloaded). */
  function nvLoadXsellRec() {
    var R = (typeof routes !== 'undefined' && routes) || {};
    var base = R.product_recommendations_url || '/recommendations/products';
    document.querySelectorAll('[data-xsell-rec]:not([data-xsell-loaded])').forEach(function (rec) {
      rec.setAttribute('data-xsell-loaded', '1');
      var pid = rec.getAttribute('data-pid');
      var track = rec.querySelector('[data-xsell-track]');
      if (!pid || !track) { rec.style.display = 'none'; return; }
      var url = base + '?section_id=nanovit-crosssell-rec&product_id=' + pid + '&limit=' + (rec.getAttribute('data-limit') || 6) + '&intent=related';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var cards = temp.querySelectorAll('.nv-card, .nv-xrow');
        if (cards.length) { cards.forEach(function (c) { track.appendChild(c); }); }
        else { rec.style.display = 'none'; }
      }).catch(function () { rec.style.display = 'none'; });
    });
  }
  nvLoadXsellRec();
  document.addEventListener('cart:update', function () { setTimeout(nvLoadXsellRec, 80); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-hero"] && !Shopify.designMode) return;
  try {
    
  class NanovitSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hero__track');
      this.viewport = this.querySelector('.hero__inner');
      this.slides = Array.from(this.querySelectorAll('.hero__slide'));

      // A11y/SEO: o video_tag do Shopify injeta um <img> de poster sem alt no
      // <video> do slide. Derivamos o alt do título do slide (roda antes do
      // early-return de slide único).
      this.querySelectorAll('video.hero__media-el > img').forEach((img) => {
        if ((img.getAttribute('alt') || '').trim()) return;
        const slide = img.closest('.hero__slide');
        const t = slide && slide.querySelector('.hero__title');
        img.setAttribute('alt', (t && t.textContent.trim()) || 'Banner Nanovit');
      });

      this.dots = Array.from(this.querySelectorAll('.hero__dot'));
      this.pauseBtn = this.querySelector('.hero__pause');
      this.progress = this.querySelector('.hero__progress-fill');
      this.fade = this.dataset.transition === 'fade';
      this.index = 0;
      this.playing = false;
      if (!this.track || this.slides.length <= 1) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = parseInt(this.getAttribute('interval'), 10) || 6000;

      this.querySelectorAll('.hero__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.go(this.index + parseInt(btn.dataset.dir, 10));
          this.restart();
        });
      });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.index, 10));
          this.restart();
        });
      });
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.toggle());

      // keyboard nav (when focus is within the slideshow)
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.go(this.index - 1); this.restart(); }
        else if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restart(); }
      });

      // swipe nav (pointer); suppress the click that follows a real swipe
      let startX = null;
      this.viewport.addEventListener('pointerdown', (e) => {
        startX = e.clientX;
        // Limpa o guarda do gesto anterior. No toque, um swipe normalmente NÃO
        // gera click, então o flag ficava pendurado e engolia o PRÓXIMO toque
        // legítimo — agora que o slide inteiro é <a>, isso viraria dead click.
        this._swiped = false;
      });
      // Browser assumiu o gesto (scroll): o pointerup não chega e o startX
      // ficaria velho, gerando um dx falso no próximo toque.
      this.viewport.addEventListener('pointercancel', () => { startX = null; });
      this.viewport.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) {
          this._swiped = true;
          this.go(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        }
      });
      this.viewport.addEventListener('click', (e) => {
        if (this._swiped) { e.preventDefault(); e.stopPropagation(); this._swiped = false; }
      }, true);

      // pause on hover
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (this.playing) this.start(); });

      this.go(0);
      if (this.hasAttribute('autoplay') && !this.reduceMotion) {
        this.playing = true;
        this.start();
      }
      this.syncPause();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(target) {
      const n = this.slides.length;
      this.index = ((target % n) + n) % n;
      if (this.fade) {
        this.slides.forEach((s, i) => s.classList.toggle('hero__slide--active', i === this.index));
      } else {
        this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
      }
      this.dots.forEach((dot, i) => dot.classList.toggle('hero__dot--active', i === this.index));
      this.tickProgress();
    }

    start() {
      this.stop();
      this.tickProgress();
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
      if (this.progress) this.progress.style.animationPlayState = 'paused';
    }

    restart() {
      if (this.playing) this.start();
    }

    toggle() {
      this.playing = !this.playing;
      if (this.playing) this.start();
      else this.stop();
      this.syncPause();
    }

    tickProgress() {
      if (!this.progress) return;
      if (!this.playing) { this.progress.style.animation = 'none'; return; }
      this.progress.style.animation = 'none';
      void this.progress.offsetWidth;
      this.progress.style.animation = 'nv-hero-progress ' + this.interval + 'ms linear';
    }

    syncPause() {
      if (!this.pauseBtn) return;
      this.pauseBtn.dataset.state = this.playing ? 'playing' : 'paused';
      this.pauseBtn.setAttribute('aria-label', this.playing ? 'Pausar' : 'Reproduzir');
    }
  }

  if (!customElements.get('nanovit-slideshow')) {
    customElements.define('nanovit-slideshow', NanovitSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-linha-nanovit"] && !Shopify.designMode) return;
  try {
    
  class NanovitCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.querySelectorAll('[data-carousel-prev]').forEach((b) =>
        b.addEventListener('click', () => this.move(-1))
      );
      this.querySelectorAll('[data-carousel-next]').forEach((b) =>
        b.addEventListener('click', () => this.move(1))
      );
    }

    move(dir) {
      const first = this.track.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 10 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
    }
  }

  if (!customElements.get('nanovit-carousel')) {
    customElements.define('nanovit-carousel', NanovitCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* navigator.clipboard não é garantido nos webviews in-app do
       Instagram/Facebook — ~70% do tráfego. Daí o fallback. */
    function copy(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        if (ok) { resolve(); } else { reject(); }
      });
    }

    function toast(msg) {
      var el = document.querySelector('.nv-marquee-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'nv-marquee-toast';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }
      el.textContent = msg;
      requestAnimationFrame(function () { el.classList.add('nv-marquee-toast--visible'); });
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.classList.remove('nv-marquee-toast--visible'); }, 2600);
    }

    function init() {
      var strips = document.querySelectorAll('.marquee');
      Array.prototype.forEach.call(strips, function (strip) {
        if (strip.dataset.nvBound) return;
        if (!strip.querySelector('[data-nv-marquee-copy]')) return;
        strip.dataset.nvBound = '1';

        /* Sem :hover no toque — pausa no primeiro contato e solta depois,
           para o segundo toque acertar o alvo parado. */
        var release = null;
        strip.addEventListener('pointerdown', function () {
          strip.classList.add('is-paused');
          clearTimeout(release);
          release = setTimeout(function () { strip.classList.remove('is-paused'); }, 4000);
        });

        strip.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('[data-nv-marquee-copy]');
          if (!btn) return;
          var code = btn.getAttribute('data-nv-marquee-copy') || '';
          var ok = strip.getAttribute('data-msg-ok') || 'Cupom copiado!';
          var fail = strip.getAttribute('data-msg-fail') || 'Copie o código: ';
          copy(code)
            .then(function () { toast(ok.replace('{codigo}', code)); })
            .catch(function () { toast(fail + code); });
        });
      });
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Copia com fallback: navigator.clipboard não é garantido nos webviews
       in-app do Instagram/Facebook, que são ~70% do tráfego. */
    function copy(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, ta.value.length);
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        if (ok) { resolve(); } else { reject(); }
      });
    }

    function bindCopy(scope) {
      var btn = scope.querySelector('[data-nv-copy]');
      if (!btn || btn.dataset.nvBound) return;
      btn.dataset.nvBound = '1';
      btn.addEventListener('click', function () {
        var hint = btn.querySelector('.newsletter__coupon-hint');
        copy(btn.getAttribute('data-nv-copy'))
          .then(function () { if (hint) hint.textContent = 'Copiado!'; })
          .catch(function () { if (hint) hint.textContent = 'Selecione o código acima e copie'; });
      });
    }

    /* Monta o mesmo bloco do snippet nv-newsletter-done via DOM (sem innerHTML,
       para não quebrar caso o lojista use aspas nos textos do editor). */
    function renderDone(wrap) {
      var coupon = (wrap.getAttribute('data-coupon') || '').trim();
      var box = document.createElement('div');
      box.className = 'newsletter__done';

      var title = document.createElement('p');
      title.className = 'newsletter__done-title';
      title.textContent = wrap.getAttribute('data-success-title') || 'Cupom liberado!';
      box.appendChild(title);

      var text = wrap.getAttribute('data-success-text');
      if (text) {
        var p = document.createElement('p');
        p.className = 'newsletter__done-text';
        p.textContent = text;
        box.appendChild(p);
      }

      if (coupon) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'newsletter__coupon';
        btn.setAttribute('data-nv-copy', coupon);
        var code = document.createElement('span');
        code.className = 'newsletter__coupon-code';
        code.textContent = coupon;
        var hint = document.createElement('span');
        hint.className = 'newsletter__coupon-hint';
        hint.textContent = wrap.getAttribute('data-copy-label') || 'Toque para copiar';
        btn.appendChild(code);
        btn.appendChild(hint);
        box.appendChild(btn);
      }

      wrap.innerHTML = '';
      wrap.appendChild(box);
      bindCopy(wrap);
    }

    function fail(formEl, btn, message) {
      if (btn) btn.disabled = false;
      if (formEl.querySelector('.newsletter__error')) return;
      var p = document.createElement('p');
      p.className = 'newsletter__error';
      p.textContent = message;
      formEl.appendChild(p);
    }

    function init() {
      var wraps = document.querySelectorAll('[data-nv-newsletter]');
      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.dataset.nvBound) return;
        wrap.dataset.nvBound = '1';

        /* Já chegou renderizado com sucesso (ramo sem JS): só liga o copiar. */
        if (wrap.querySelector('[data-nv-copy]')) { bindCopy(wrap); return; }

        var formEl = wrap.querySelector('.newsletter__form');
        if (!formEl) return;

        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = formEl.querySelector('[type="submit"]');
          if (btn) btn.disabled = true;
          var old = formEl.querySelector('.newsletter__error');
          if (old && old.parentNode) old.parentNode.removeChild(old);

          fetch(formEl.action, { method: 'POST', body: new FormData(formEl), headers: { Accept: 'text/html' } })
            .then(function (r) { return { url: r.url || '', redirected: !!r.redirected }; })
            .then(function (res) {
              /* Shopify redireciona para ?customer_posted=true no sucesso. */
              if (res.redirected || res.url.indexOf('posted=true') !== -1) {
                renderDone(wrap);
              } else {
                fail(formEl, btn, 'Confira o e-mail e tente de novo.');
              }
            })
            .catch(function () {
              fail(formEl, btn, 'Não foi possível enviar agora. Tente de novo.');
            });
        });
      });
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.getElementById('nv-popup');
      if (!root || root.dataset.nvBound) return;
      root.dataset.nvBound = '1';

      var trigger = root.getAttribute('data-trigger') || 'time';
      var delay = (parseFloat(root.getAttribute('data-delay')) || 0) * 1000;
      var scrollPct = parseInt(root.getAttribute('data-scroll'), 10) || 60;
      var days = parseInt(root.getAttribute('data-days'), 10) || 2;
      var isEditor = window.Shopify && window.Shopify.designMode;
      var key = 'nv_popup_last';
      var shown = false, onScroll = null;

      function close() {
        root.classList.remove('nv-popup--open');
        setTimeout(function () { root.hidden = true; }, 350);
      }
      function show(ignoreFreq) {
        if (shown) return;
        shown = true;
        if (onScroll) { window.removeEventListener('scroll', onScroll); onScroll = null; }
        root.hidden = false;
        requestAnimationFrame(function () { root.classList.add('nv-popup--open'); });
        if (!isEditor && !ignoreFreq) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
      }
      root.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

      // ---- optional form: submit via AJAX, show thank-you inline ----
      var formWrap = root.querySelector('[data-popup-form]');
      var formEl = formWrap && formWrap.querySelector('.nv-popup__formel');
      if (formEl) {
        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = formEl.querySelector('[type="submit"]');
          if (btn) btn.disabled = true;
          var old = formEl.querySelector('.nv-popup__form-error');
          if (old) old.parentNode.removeChild(old);
          fetch(formEl.action, { method: 'POST', body: new FormData(formEl), headers: { Accept: 'text/html' } })
            .then(function (r) { return { url: r.url || '', redirected: !!r.redirected }; })
            .then(function (res) {
              if (res.redirected || res.url.indexOf('posted=true') !== -1) {
                var msg = formWrap.getAttribute('data-success') || 'Pronto! Recebemos seu contato.';
                formWrap.innerHTML = '<p class="nv-popup__form-success">' + msg + '</p>';
              } else {
                if (btn) btn.disabled = false;
                var p = document.createElement('p');
                p.className = 'nv-popup__form-error';
                p.textContent = 'Não foi possível enviar agora. Confira o e-mail e tente de novo.';
                formEl.appendChild(p);
              }
            })
            .catch(function () {
              if (btn) btn.disabled = false;
              var p = document.createElement('p');
              p.className = 'nv-popup__form-error';
              p.textContent = 'Não foi possível enviar agora. Tente de novo.';
              formEl.appendChild(p);
            });
        });
      }

      // ---- editor: don't auto-open on navigation; preview by selecting the section ----
      var sectionEl = root.closest('.shopify-section');
      if (isEditor) {
        document.addEventListener('shopify:section:select', function (e) {
          if (sectionEl && sectionEl.id === 'shopify-section-' + e.detail.sectionId) { shown = false; show(true); }
        });
        return;
      }

      // ---- live: respect the interval, then trigger by time or scroll ----
      var last = 0;
      try { last = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
      if (Date.now() - last < days * 86400000) return;

      if (trigger === 'scroll') {
        onScroll = function () {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          var pct = max > 0 ? (window.scrollY / max) * 100 : 100;
          if (pct >= scrollPct) show();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else if (trigger === 'exit') {
        // saída do mouse (exit-intent): só faz sentido em desktop com ponteiro.
        // em telas de toque (sem hover) cai para o atraso por tempo.
        var hasHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
        if (!hasHover) {
          setTimeout(function () { show(); }, delay);
        } else {
          var onLeave = function (e) {
            // ponteiro saiu pelo topo da janela e não foi para outro elemento
            if (e.clientY <= 0 && !e.relatedTarget) {
              show();
              document.removeEventListener('mouseout', onLeave);
            }
          };
          document.addEventListener('mouseout', onLeave);
        }
      } else {
        setTimeout(function () { show(); }, delay);
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-quickbuy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.getElementById('nv-quickbuy');
      if (!root || root.dataset.nvBound) return;
      root.dataset.nvBound = '1';

      var tabs = root.querySelectorAll('[data-qb-tab]');
      var panels = root.querySelectorAll('[data-qb-panel]');

      // ---- tab overflow arrows ----
      var tabsEl = root.querySelector('[data-qb-tabs]');
      var tabPrev = root.querySelector('[data-qb-tabs-prev]');
      var tabNext = root.querySelector('[data-qb-tabs-next]');
      function updateTabArrows() {
        if (!tabsEl) return;
        var max = tabsEl.scrollWidth - tabsEl.clientWidth;
        var x = tabsEl.scrollLeft;
        var overflow = max > 2;
        if (tabPrev) tabPrev.hidden = !overflow || x <= 2;
        if (tabNext) tabNext.hidden = !overflow || x >= max - 2;
      }
      if (tabsEl) {
        tabsEl.addEventListener('scroll', updateTabArrows, { passive: true });
        if (tabPrev) tabPrev.addEventListener('click', function () { tabsEl.scrollBy({ left: -tabsEl.clientWidth * 0.7, behavior: 'smooth' }); });
        if (tabNext) tabNext.addEventListener('click', function () { tabsEl.scrollBy({ left: tabsEl.clientWidth * 0.7, behavior: 'smooth' }); });
        // O ResizeObserver já cobre o resize da janela (tabsEl é fluido); o
        // listener de window vira só fallback, e com debounce — updateTabArrows
        // lê scrollWidth/clientWidth, que força reflow.
        if ('ResizeObserver' in window) {
          new ResizeObserver(updateTabArrows).observe(tabsEl);
        } else {
          var tabsT;
          window.addEventListener('resize', function () {
            clearTimeout(tabsT);
            tabsT = setTimeout(updateTabArrows, 150);
          });
        }
      }

      // ---- hidratação: monta os cards a partir do JSON no 1º open ----
      // (o servidor manda só o dado; ver comentário no markup)
      var hydrated = false;
      function esc(s) {
        return String(s == null ? '' : s)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      var PLUS = '<svg class="nv-qb__add-plus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      var CHECK = '<svg class="nv-qb__add-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

      function priceHtml(price, compare) {
        return (compare ? '<s>' + esc(compare) + '</s> ' : '') + esc(price);
      }

      function card(p) {
        var media = p.i
          ? '<img src="' + esc(p.i) + '" width="64" height="64" loading="lazy" alt="' + esc(p.t) + '" class="nv-qb__product-img">'
          : '';
        var vs = p.vs || [];
        // seletor de kit inline (mesma convenção do carrinho e do quiz):
        // escolhendo aqui, o "+" adiciona direto e não abre o pop-up
        var picker = '';
        if (vs.length > 1) {
          picker = '<select class="nv-qb__variant" aria-label="Escolha a opção">' +
            vs.map(function (v) {
              return '<option value="' + esc(v.id) + '"' +
                ' data-p="' + esc(v.p) + '" data-c="' + esc(v.c || '') + '"' +
                (String(v.id) === String(p.v) ? ' selected' : '') +
                (v.a ? '' : ' disabled') + '>' +
                esc(v.l) + (v.a ? '' : ' · esgotado') + '</option>';
            }).join('') + '</select>';
        }
        // com seletor inline o multi vira 0: a variante já está escolhida
        var multiAttr = (vs.length > 1) ? '0' : (p.m ? '1' : '0');
        var action = p.a
          ? '<button type="button" class="nv-qb__add" data-xsell-add data-multi="' + multiAttr +
            '" data-variant-id="' + esc(p.v) + '" data-handle="' + esc(p.h) +
            '" data-title="' + esc(p.t) + '" data-tags="' + esc(p.g) +
            '" aria-label="Adicionar ' + esc(p.t) + '">' + PLUS + CHECK + '</button>'
          : '<span class="nv-qb__sold">Esgotado</span>';
        return '<div class="nv-qb__product">' +
          '<a href="' + esc(p.u) + '" class="nv-qb__product-media">' + media + '</a>' +
          '<div class="nv-qb__product-info">' +
            '<a href="' + esc(p.u) + '" class="nv-qb__product-title">' + esc(p.t) + '</a>' +
            '<span class="nv-qb__product-price">' + priceHtml(p.p, p.c) + '</span>' +
            picker +
          '</div>' + action +
        '</div>';
      }

      // trocar o kit atualiza preço e a variante que o "+" vai adicionar
      root.addEventListener('change', function (e) {
        var sel = e.target.closest ? e.target.closest('.nv-qb__variant') : null;
        if (!sel) return;
        var opt = sel.options[sel.selectedIndex];
        var wrap = sel.closest('.nv-qb__product');
        if (!opt || !wrap) return;
        var priceEl = wrap.querySelector('.nv-qb__product-price');
        if (priceEl) priceEl.innerHTML = priceHtml(opt.getAttribute('data-p'), opt.getAttribute('data-c'));
        var btn = wrap.querySelector('.nv-qb__add');
        if (btn) btn.setAttribute('data-variant-id', sel.value);
      });

      function hydrate() {
        if (hydrated) return;
        hydrated = true;
        var src = root.querySelector('[data-qb-data]');
        var data = [];
        if (src) { try { data = JSON.parse(src.textContent); } catch (e) { data = []; } }
        panels.forEach(function (panel, i) {
          var items = (data && data[i]) || [];
          panel.innerHTML = items.length
            ? items.map(card).join('')
            : '<p class="nv-qb__empty">Escolha uma coleção com produtos para esta categoria.</p>';
        });
      }

      function open() {
        hydrate();
        root.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () { root.classList.add('nv-qb--open'); updateTabArrows(); });
        setTimeout(updateTabArrows, 320);
      }
      function close() {
        root.classList.remove('nv-qb--open');
        document.body.style.overflow = '';
        setTimeout(function () { root.hidden = true; }, 300);
      }
      function selectTab(i) {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-qb-tab') === String(i)); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-qb-panel') === String(i)); });
      }

      document.querySelectorAll('[data-qb-open]').forEach(function (b) { b.addEventListener('click', open); });
      root.querySelectorAll('[data-qb-close]').forEach(function (b) { b.addEventListener('click', close); });
      tabs.forEach(function (t) { t.addEventListener('click', function () { selectTab(t.getAttribute('data-qb-tab')); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

      // O "Adicionar" usa o mecanismo global data-xsell-add (pop-up de variações
      // #nv-vmodal + add-to-cart), definido no header. Nada a fazer aqui.
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initQuiz() {
      var root = document.getElementById('nv-quiz');
      if (!root || root.dataset.nvQuizBound) return;
      root.dataset.nvQuizBound = '1';

      var screens = root.querySelectorAll('[data-quiz-screen]');
      var questions = root.querySelectorAll('[data-quiz-screen="question"]');
      var resultList = root.querySelector('[data-quiz-result-list]');
      var emptyMsg = root.querySelector('[data-quiz-empty]');
      var addAllBtn = root.querySelector('[data-quiz-add-all]');
      var noticeEl = root.querySelector('[data-quiz-notice]');
      var selected = [];

      function setNotice(msg) {
        if (!noticeEl) return;
        if (msg) { noticeEl.textContent = msg; noticeEl.hidden = false; noticeEl.style.display = ''; }
        else { noticeEl.textContent = ''; noticeEl.hidden = true; noticeEl.style.display = 'none'; }
      }
      // quantos itens selecionados estão de fato disponíveis
      function availCount() {
        return selected.filter(function (p) { return p.avail !== false; }).length;
      }
      // habilita/desabilita o botão e mostra o aviso conforme a disponibilidade
      function refreshAddState() {
        var total = selected.length;
        var ok = availCount();
        if (addAllBtn) {
          addAllBtn.disabled = ok === 0;
          addAllBtn.style.opacity = ok === 0 ? '0.55' : '';
        }
        if (ok === 0 && total > 0) {
          setNotice('Os itens selecionados estão indisponíveis no momento.');
        } else if (ok < total) {
          setNotice('Alguns itens estão esgotados e não serão adicionados.');
        } else {
          setNotice('');
        }
      }
      var step = 0;

      function show(name, stepIndex) {
        screens.forEach(function (sc) {
          var isMatch = sc.getAttribute('data-quiz-screen') === name;
          if (isMatch && name === 'question') {
            isMatch = String(sc.getAttribute('data-quiz-step')) === String(stepIndex);
          }
          sc.hidden = !isMatch;
        });
      }
      function openQuiz() {
        selected = [];
        step = 0;
        show('intro');
        if (typeof root.showModal === 'function') { root.showModal(); } else { root.setAttribute('open', ''); }
      }
      function openToQuestion() {
        selected = [];
        step = 0;
        if (questions.length > 0) { show('question', 0); } else { show('intro'); }
        if (typeof root.showModal === 'function') { root.showModal(); } else { root.setAttribute('open', ''); }
      }
      function closeQuiz() {
        if (typeof root.close === 'function') { root.close(); } else { root.removeAttribute('open'); }
      }
      function gotoStep(i) {
        if (i >= questions.length) { showResult(); return; }
        step = i;
        show('question', i);
      }
      function answer(isYes) {
        var q = questions[step];
        if (isYes && q && q.getAttribute('data-variant-id')) {
          var variants = null;
          try { variants = JSON.parse(q.getAttribute('data-variants') || 'null'); } catch (e) { variants = null; }
          selected.push({
            id: q.getAttribute('data-variant-id'),
            title: q.getAttribute('data-product-title') || '',
            image: q.getAttribute('data-product-image') || '',
            price: q.getAttribute('data-product-price') || '',
            compareAt: q.getAttribute('data-product-compare-at') || '',
            variants: variants,
            avail: q.getAttribute('data-variant-available') !== 'false'
          });
        }
        gotoStep(step + 1);
      }
      function showResult() {
        if (resultList) resultList.innerHTML = '';
        var hasItems = selected.length > 0;
        // Drive visibility from selected.length and force it via inline display:
        // the `hidden` attribute alone is unreliable here because the theme sets
        // `display` on some elements, which overrides the native [hidden] rule.
        if (emptyMsg) {
          emptyMsg.hidden = hasItems;
          emptyMsg.classList.toggle('is-hidden', hasItems);
          emptyMsg.setAttribute('aria-hidden', hasItems ? 'true' : 'false');
          emptyMsg.style.display = hasItems ? 'none' : '';
        }
        if (addAllBtn) {
          addAllBtn.hidden = !hasItems;
          addAllBtn.style.display = hasItems ? '' : 'none';
          addAllBtn.disabled = false;
        }
        setNotice('');
        if (hasItems) {
          selected.forEach(function (p) {
            var item = document.createElement('div');
            item.className = 'nv-quiz__result-item';
            var html = '';
            if (p.image) { html += '<img src="' + p.image + '" alt="" class="nv-quiz__result-img">'; }
            html += '<div class="nv-quiz__result-info"><span class="nv-quiz__result-title"></span></div>';
            html += '<span class="nv-quiz__result-price"></span>';
            item.innerHTML = html;
            item.querySelector('.nv-quiz__result-title').textContent = p.title;
            // marca visualmente os esgotados (não entram no adicionar em lote)
            function applyAvail() {
              item.classList.toggle('nv-quiz__result-item--soldout', p.avail === false);
            }
            applyAvail();
            var priceEl = item.querySelector('.nv-quiz__result-price');
            function updatePriceDisplay() {
              if (!priceEl) return;
              priceEl.innerHTML = '';
              if (p.compareAt) {
                var compareEl = document.createElement('s');
                compareEl.className = 'nv-quiz__result-compare';
                compareEl.textContent = p.compareAt;
                priceEl.appendChild(compareEl);
              }
              var currentEl = document.createElement('span');
              currentEl.textContent = p.price;
              priceEl.appendChild(currentEl);
            }
            updatePriceDisplay();

            // dropdown de Quantidade: escolher o kit antes do adicionar em lote
            if (p.variants && p.variants.length > 1) {
              var sel = document.createElement('select');
              sel.className = 'nv-quiz__result-variant';
              sel.setAttribute('aria-label', 'Escolha a quantidade');
              p.variants.forEach(function (v) {
                var opt = document.createElement('option');
                opt.value = String(v.id);
                // pote esgotado: rótulo claro + desabilitado (os demais seguem
                // selecionáveis, então 1 pote sem estoque não bloqueia o produto)
                opt.textContent = v.label + ' · ' + v.price + (v.avail === false ? ' · esgotado' : '');
                if (!v.avail) opt.disabled = true;
                sel.appendChild(opt);
              });
              sel.value = String(p.id);
              sel.addEventListener('change', function () {
                p.id = sel.value;
                var chosen = null;
                p.variants.forEach(function (v) { if (String(v.id) === sel.value) chosen = v; });
                if (chosen) {
                  p.price = chosen.price;
                  p.compareAt = chosen.compareAt || '';
                  p.avail = chosen.avail !== false;
                  updatePriceDisplay();
                  applyAvail();
                  refreshAddState();
                }
              });
              item.querySelector('.nv-quiz__result-info').appendChild(sel);
            }

            if (resultList) resultList.appendChild(item);
          });
          refreshAddState();
        }
        show('result');
      }
      function addAll() {
        if (!addAllBtn) return;
        // adiciona SÓ os disponíveis: um item esgotado no lote faz o Shopify
        // recusar tudo (422), que era o bug de "não adiciona nada".
        var items = selected
          .filter(function (p) { return p.avail !== false; })
          .map(function (p) { return { id: p.id, quantity: 1 }; });
        if (!items.length) { refreshAddState(); return; }

        addAllBtn.disabled = true;
        var routes = (typeof window.routes !== 'undefined' && window.routes) || (window.Theme && window.Theme.routes) || {};
        var addUrl = routes.cart_add_url || '/cart/add';
        var cartUrl = routes.cart_url || '/cart';
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          sectionIds.push(el.dataset.sectionId);
        });
        // endpoint AJAX (.js): o /cart/add "cru" pode redirecionar em vez de devolver JSON
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok || res.body.status) {
              // não fecha o modal: reabilita e avisa em vez de sumir em silêncio
              addAllBtn.disabled = false;
              setNotice(res.body.description || 'Não foi possível adicionar. Tente novamente.');
              return;
            }
            var data = res.body;
            return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: 'nv-quiz',
                    data: { source: 'nv-quiz', sections: data.sections, itemCount: cart.item_count }
                  }
                }));
                closeQuiz();
                var drawer = document.querySelector('cart-drawer-component');
                if (drawer && typeof drawer.open === 'function') { drawer.open(); }
              });
          })
          .catch(function (e) {
            console.error(e);
            addAllBtn.disabled = false;
            setNotice('Não foi possível adicionar. Tente novamente.');
          });
      }

      root.querySelectorAll('[data-quiz-close]').forEach(function (b) { b.addEventListener('click', closeQuiz); });
      var startBtn = root.querySelector('[data-quiz-start]');
      if (startBtn) startBtn.addEventListener('click', function () { gotoStep(0); });
      root.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        b.addEventListener('click', function () { answer(b.getAttribute('data-quiz-answer') === 'yes'); });
      });
      if (addAllBtn) addAllBtn.addEventListener('click', addAll);
      var restartBtn = root.querySelector('[data-quiz-restart]');
      if (restartBtn) restartBtn.addEventListener('click', openQuiz);
      // close when clicking the backdrop (outside the inner dialog)
      root.addEventListener('click', function (e) { if (e.target === root) closeQuiz(); });

      // wire the nav trigger (the menu item whose label matches trigger_label):
      // hover shows a dropdown (intro text + "Começar"); click opens the modal
      // straight at the first question. The intro screen stays for "Refazer".
      var label = (root.getAttribute('data-trigger-label') || '').trim();
      if (label) {
        var intro = root.querySelector('[data-quiz-screen="intro"]');
        var ddHeading = intro && intro.querySelector('.nv-quiz__title');
        var ddText = intro && intro.querySelector('.nv-quiz__text');
        var ddStart = intro && intro.querySelector('[data-quiz-start]');
        var startLabel = (ddStart && ddStart.textContent.trim()) || 'Começar';
        document.querySelectorAll('.nv-header__nav a').forEach(function (a) {
          if (a.textContent.trim() !== label) return;
          a.setAttribute('data-nv-quiz-trigger', '');
          var item = a.closest('.nv-nav-item') || a.parentNode;
          item.classList.add('nv-quiz-nav');
          var dd = document.createElement('div');
          dd.className = 'nv-quiz-dropdown';
          var html = '';
          if (ddHeading) { html += '<div class="nv-quiz-dropdown__title">' + ddHeading.textContent + '</div>'; }
          if (ddText) { html += '<div class="nv-quiz-dropdown__text">' + ddText.innerHTML + '</div>'; }
          html += '<button type="button" class="nv-quiz-dropdown__btn">' + startLabel + '</button>';
          dd.innerHTML = html;
          item.appendChild(dd);
          dd.querySelector('.nv-quiz-dropdown__btn').addEventListener('click', openToQuestion);
          a.addEventListener('click', function (e) { e.preventDefault(); openToQuestion(); });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuiz);
    } else {
      initQuiz();
    }
    document.addEventListener('shopify:section:load', initQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function setupDrag(root) {
      var inner = root.querySelector('.nv-timer__inner');
      if (!inner) return;
      var key = 'nvt-pos-' + (root.dataset.end || '');
      function applyPos(x, y) {
        root.style.left = x + 'px';
        root.style.top = y + 'px';
        root.style.right = 'auto';
        root.style.bottom = 'auto';
      }
      try {
        var saved = JSON.parse(localStorage.getItem(key));
        if (saved && typeof saved.x === 'number') applyPos(saved.x, saved.y);
      } catch (e) {}
      var dragging = false, sx = 0, sy = 0, ox = 0, oy = 0;
      inner.addEventListener('pointerdown', function (e) {
        if (e.target.closest('a, button, video, [data-nvt-close], [data-nvt-video]')) return;
        dragging = true;
        var r = root.getBoundingClientRect();
        ox = r.left; oy = r.top; sx = e.clientX; sy = e.clientY;
        root.classList.add('is-dragging');
        try { inner.setPointerCapture(e.pointerId); } catch (e2) {}
      });
      inner.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var nx = ox + (e.clientX - sx);
        var ny = oy + (e.clientY - sy);
        nx = Math.max(8, Math.min(window.innerWidth - root.offsetWidth - 8, nx));
        ny = Math.max(8, Math.min(window.innerHeight - root.offsetHeight - 8, ny));
        applyPos(nx, ny);
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        try { localStorage.setItem(key, JSON.stringify({ x: parseFloat(root.style.left), y: parseFloat(root.style.top) })); } catch (e) {}
      }
      inner.addEventListener('pointerup', endDrag);
      inner.addEventListener('pointercancel', endDrag);
    }

    function initTimer(root) {
      if (!root || root.__nvtBound) return;
      root.__nvtBound = true;

      var end = new Date(root.dataset.end).getTime();
      if (isNaN(end)) return; // data não configurada -> fica oculto

      var display = root.dataset.display;
      var expiredAction = root.dataset.expired;
      var trigger = root.dataset.trigger || 'immediately';
      var delay = parseInt(root.dataset.delay || '0', 10) || 0;
      var scrollPct = parseInt(root.dataset.scroll || '0', 10) || 0;
      var progressHours = parseFloat(root.dataset.progress || '0') || 0;

      var clock = root.querySelector('[data-nvt-clock]');
      var expiredEl = root.querySelector('[data-nvt-expired]');
      var progressBar = root.querySelector('[data-nvt-progress-bar]');
      var f = {
        days: root.querySelector('[data-nvt="days"]'),
        hours: root.querySelector('[data-nvt="hours"]'),
        minutes: root.querySelector('[data-nvt="minutes"]'),
        seconds: root.querySelector('[data-nvt="seconds"]')
      };

      // fechar (dismiss) — some só nesta visualização; volta no próximo
      // carregamento da página (sem persistência)
      if (root.dataset.dismissible === 'true') {
        var closeBtn = root.querySelector('[data-nvt-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () {
          root.hidden = true;
        });
      }

      if (root.dataset.draggable === 'true') setupDrag(root);

      // minimizar (full): esconde a barra e mostra o sticker; persiste por visitante
      var minBtn = root.querySelector('[data-nvt-min]');
      var restoreBtn = root.querySelector('[data-nvt-restore]');
      if (minBtn || restoreBtn) {
        var minKey = 'nvt-min-' + end;
        var setMin = function (on) {
          root.classList.toggle('is-minimized', on);
          try { if (on) { localStorage.setItem(minKey, '1'); } else { localStorage.removeItem(minKey); } } catch (e) {}
        };
        try { if (localStorage.getItem(minKey)) root.classList.add('is-minimized'); } catch (e) {}
        if (minBtn) minBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setMin(true); });
        if (restoreBtn) restoreBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setMin(false); });
      }

      // vídeo: autoplay mudo (markup), clique no vídeo ativa/desativa o som
      var videoMedia = root.querySelector('[data-nvt-video]');
      if (videoMedia) {
        var vid = videoMedia.querySelector('video');
        videoMedia.addEventListener('click', function () {
          if (!vid) return;
          if (vid.muted) {
            vid.muted = false;
            videoMedia.classList.add('is-unmuted');
            var p = vid.play(); if (p && p.catch) p.catch(function () {});
          } else {
            vid.muted = true;
            videoMedia.classList.remove('is-unmuted');
          }
        });
      }

      var revealed = false, expired = false;
      function reveal() {
        if (revealed || expired) return;
        revealed = true;
        root.hidden = false;
        requestAnimationFrame(function () { root.classList.add('is-in'); });
      }

      var timer;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          expired = true;
          if (expiredAction === 'message' && expiredEl) {
            if (clock) clock.hidden = true;
            expiredEl.hidden = false;
            root.hidden = false;
          } else {
            root.hidden = true;
          }
          if (timer) clearInterval(timer);
          return;
        }
        var totalSec = Math.floor(diff / 1000);
        var minutes = Math.floor((totalSec % 3600) / 60), seconds = totalSec % 60, hours;
        if (display === 'horas') {
          hours = Math.floor(totalSec / 3600);
        } else {
          hours = Math.floor((totalSec % 86400) / 3600);
          if (f.days) f.days.textContent = pad(Math.floor(totalSec / 86400));
        }
        if (f.hours) f.hours.textContent = pad(hours);
        if (f.minutes) f.minutes.textContent = pad(minutes);
        if (f.seconds) f.seconds.textContent = pad(seconds);
        if (progressBar && progressHours > 0) {
          var win = progressHours * 3600000;
          var filled = Math.min(1, Math.max(0, (win - diff) / win));
          progressBar.style.width = (filled * 100).toFixed(1) + '%';
        }
      }
      tick();
      timer = setInterval(tick, 1000);

      // aparição
      if (trigger === 'delay') {
        setTimeout(reveal, delay * 1000);
      } else if (trigger === 'scroll') {
        var onScroll = function () {
          var sc = window.scrollY || document.documentElement.scrollTop;
          var h = document.documentElement.scrollHeight - window.innerHeight;
          var pct = h > 0 ? (sc / h) * 100 : 100;
          if (pct >= scrollPct) { reveal(); window.removeEventListener('scroll', onScroll); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      } else {
        reveal();
      }
    }

    function initAll() { document.querySelectorAll('nv-timer').forEach(initTimer); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-usam-indicam"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIndicam() {
      document.querySelectorAll('.indicam:not([data-nv-indicam])').forEach(function (root) {
        root.setAttribute('data-nv-indicam', '1');
        var videos = Array.prototype.slice.call(root.querySelectorAll('video.indicam-ugc__bg'));
        if (!videos.length) return;

        // A11y/SEO: o video_tag do Shopify injeta um <img> de poster sem alt.
        // Derivamos um alt com significado (legenda / nome do produto do card).
        videos.forEach(function (v) {
          var img = v.querySelector('img');
          if (!img || (img.getAttribute('alt') || '').trim()) return;
          var card = v.closest('.indicam-ugc');
          var hl = card && card.querySelector('.indicam-ugc__headline');
          var nm = card && card.querySelector('.indicam-ugc__name');
          var label = (hl && hl.textContent.trim())
            || (nm && ('Depoimento sobre ' + nm.textContent.trim()))
            || 'Depoimento de cliente Nanovit';
          img.setAttribute('alt', label);
        });

        // Loop only while in the viewport: play when visible, pause when out.
        // Toca SOMENTE os vídeos realmente visíveis no trilho (não todos de uma
        // vez). Sem isso, ao chegar na seção todos os vídeos da fila estão na
        // mesma faixa vertical e disparam play() juntos -> N vídeos decodificando
        // travam o navegador. Aqui: 'io' usa o trilho como root (visibilidade
        // horizontal) e 'gate' pausa tudo quando a seção sai da viewport.
        // Os vídeos têm preload="none": o fetch/decoder só inicia no play(), e o
        // gate escalona os plays (um por vez) começando ~300px antes da seção
        // entrar na tela, então o custo acontece fora do scroll visível.
        if ('IntersectionObserver' in window) {
          var track = root.querySelector('[data-carousel-track]') || null;
          var inView = false;
          var visible = [];
          function playV(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          function muteV(v) { if (!v.muted) { v.muted = true; var w = v.closest('.indicam-ugc__video-wrap'); if (w) w.classList.remove('is-unmuted'); } }
          function playStaggered() {
            visible.forEach(function (v, i) {
              setTimeout(function () {
                if (inView && visible.indexOf(v) !== -1) playV(v);
              }, i * 250);
            });
          }

          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var v = e.target;
              var idx = visible.indexOf(v);
              if (e.isIntersecting) {
                if (idx === -1) visible.push(v);
                if (inView) playV(v);
              } else {
                if (idx !== -1) visible.splice(idx, 1);
                v.pause();
                muteV(v);
              }
            });
          }, { root: track, threshold: 0.6 });
          videos.forEach(function (v) { io.observe(v); });

          var gate = new IntersectionObserver(function (es) {
            inView = es[0].isIntersecting;
            if (inView) { playStaggered(); }
            else { videos.forEach(function (v) { v.pause(); }); }
          }, { threshold: 0, rootMargin: '300px 0px' });
          gate.observe(root);
        }

        // Click the video to toggle sound; unmuting one mutes the others.
        videos.forEach(function (v) {
          var wrap = v.closest('.indicam-ugc__video-wrap');
          v.addEventListener('click', function () {
            if (v.muted) {
              videos.forEach(function (o) {
                if (o !== v) { o.muted = true; var ow = o.closest('.indicam-ugc__video-wrap'); if (ow) ow.classList.remove('is-unmuted'); }
              });
              v.muted = false;
              if (wrap) wrap.classList.add('is-unmuted');
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            } else {
              v.muted = true;
              if (wrap) wrap.classList.remove('is-unmuted');
            }
          });
        });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initIndicam); } else { initIndicam(); }
    document.addEventListener('shopify:section:load', initIndicam);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nanovit-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root, listEl, emptyEl, footEl, customerId;
    var productCache = {};

    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }
    function noTrailing(u) { return u.charAt(u.length - 1) === '/' ? u.slice(0, -1) : u; }
    function storageKey() { return 'nv_wishlist_' + (customerId || 'guest'); }
    function metaKey() { return 'nv_wishlist_meta_' + (customerId || 'guest'); }
    function getList() {
      try { return JSON.parse(localStorage.getItem(storageKey())) || []; } catch (e) { return []; }
    }
    function setList(arr) {
      try { localStorage.setItem(storageKey(), JSON.stringify(arr)); } catch (e) {}
      updateBadges();
      markHearts();
    }
    function getMeta() {
      try { return JSON.parse(localStorage.getItem(metaKey())) || {}; } catch (e) { return {}; }
    }
    function setMeta(m) { try { localStorage.setItem(metaKey(), JSON.stringify(m)); } catch (e) {} }
    function rememberMeta(handle, title, tags) {
      if (!handle) return;
      var m = getMeta();
      // the card heart is the source of truth -> mark fetched so we don't re-fetch
      m[handle] = { title: title || '', tags: tags || '', fetched: true };
      setMeta(m);
    }
    function toggle(handle, info) {
      if (!handle) return;
      var arr = getList();
      var i = arr.indexOf(handle);
      if (i === -1) {
        arr.push(handle);
        if (info) rememberMeta(handle, info.title, info.tags);
      } else {
        arr.splice(i, 1);
      }
      setList(arr);
    }
    function updateBadges() {
      var n = getList().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }
    function markHearts() {
      var arr = getList();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var on = arr.indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function money(cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
      try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
      catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
    }
    function sized(url, w) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }
    function escapeHtml(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function pickVariant(p) {
      if (!p || !p.variants || !p.variants.length) return null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i]; }
      return p.variants[0];
    }
    function hasRealVariants(p) {
      if (!p || !p.variants || p.variants.length <= 1) return false;
      // single "Default Title" variant -> treat as no variant choice
      if (p.variants.length === 1 && p.variants[0].title === 'Default Title') return false;
      return true;
    }
    function priceHtml(price, compare) {
      var html = '';
      if (compare && compare > price) html += '<s>' + money(compare) + '</s> ';
      html += '<span class="nv-wish__price-now">' + money(price) + '</span>';
      return html;
    }
    function tagsHtml(str) {
      if (!str) return '';
      var parts = str.split(',').map(function (t) { return t.trim(); }).filter(Boolean).slice(0, 4);
      if (!parts.length) return '';
      return '<div class="nv-wish__tags">' + parts.map(function (t, i) {
        return '<span class="nv-wish__tag nv-tag--' + (i % 10) + '">' + escapeHtml(t) + '</span>';
      }).join('') + '</div>';
    }
    function variantSelectHtml(p) {
      if (!hasRealVariants(p)) return '';
      var opts = p.variants.map(function (v) {
        var label = v.title + (v.available ? '' : ' — esgotado');
        return '<option value="' + v.id + '" data-price="' + v.price + '" data-compare="' + (v.compare_at_price || 0) + '"' + (v.available ? '' : ' disabled') + '>' + escapeHtml(label) + '</option>';
      }).join('');
      return '<select class="nv-wish__variant" data-wish-variant aria-label="Escolha a variação">' + opts + '</select>';
    }

    // nome curto + tags vêm dos metafields (que /products/x.js não traz). Busca
    // via Section Rendering API e guarda em cache (localStorage) por handle.
    function metaUrl(handle) { return rootUrl() + 'products/' + handle + '?section_id=nanovit-wish-meta'; }
    function resolveMeta(handle) {
      var cached = getMeta()[handle];
      if (cached && cached.fetched) return Promise.resolve(cached);
      return fetch(metaUrl(handle), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var data = { title: '', tags: '' };
          try {
            var sc = new DOMParser().parseFromString(html, 'text/html').getElementById('nv-wish-meta');
            if (sc) { var j = JSON.parse(sc.textContent); data.title = j.title || ''; data.tags = j.tags || ''; }
          } catch (e) {}
          var existing = getMeta()[handle] || {};
          var merged = { title: existing.title || data.title, tags: existing.tags || data.tags, fetched: true };
          var all = getMeta(); all[handle] = merged; setMeta(all);
          return merged;
        })
        .catch(function () { return cached || { title: '', tags: '' }; });
    }

    function renderList() {
      if (!listEl) return;
      var arr = getList();
      listEl.innerHTML = '';
      if (footEl) footEl.hidden = !arr.length;
      if (!arr.length) { if (emptyEl) emptyEl.hidden = false; return; }
      if (emptyEl) emptyEl.hidden = true;

      arr.forEach(function (handle) {
        Promise.all([
          fetch(rootUrl() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }),
          resolveMeta(handle)
        ])
          .then(function (resArr) {
            var p = resArr[0];
            if (!p) return;
            productCache[handle] = p;
            var info = resArr[1] || {};
            var name = info.title || p.title;
            var firstVar = pickVariant(p);
            var img = sized(p.featured_image, 140);

            var row = document.createElement('div');
            row.className = 'nv-wish__item';
            row.setAttribute('data-wish-row', handle);
            if (firstVar) row.setAttribute('data-variant-id', firstVar.id);

            row.innerHTML =
              '<a class="nv-wish__item-media" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div class="nv-wish__item-info">' +
                '<a class="nv-wish__item-title" href="' + p.url + '">' + escapeHtml(name) + '</a>' +
                tagsHtml(info.tags) +
                variantSelectHtml(p) +
                '<div class="nv-wish__item-price" data-wish-price>' + priceHtml((firstVar ? firstVar.price : p.price), (firstVar ? firstVar.compare_at_price : 0)) + '</div>' +
              '</div>' +
              '<button type="button" class="nv-wish__item-remove" data-wish-remove="' + handle + '" aria-label="Remover">&times;</button>';

            var sel = row.querySelector('[data-wish-variant]');
            if (sel && firstVar) {
              sel.value = String(firstVar.id);
              sel.addEventListener('change', function () {
                var opt = sel.options[sel.selectedIndex];
                row.setAttribute('data-variant-id', sel.value);
                var pr = parseInt(opt.getAttribute('data-price'), 10) || 0;
                var cmp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
                var priceEl = row.querySelector('[data-wish-price]');
                if (priceEl) priceEl.innerHTML = priceHtml(pr, cmp);
              });
            }
            listEl.appendChild(row);
          })
          .catch(function () {});
      });
    }

    // ---- add-all to cart (per-product selected variant) / shareable permalink ----
    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch(rootUrl() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productCache[handle] = p; return p; });
    }
    function collectItems() {
      return Promise.all(getList().map(function (handle) {
        var row = listEl && listEl.querySelector('[data-wish-row="' + handle + '"]');
        if (row && row.getAttribute('data-variant-id')) {
          return Promise.resolve({ id: row.getAttribute('data-variant-id'), quantity: 1 });
        }
        return fetchProduct(handle).then(function (p) { var v = pickVariant(p); return v ? { id: v.id, quantity: 1 } : null; });
      })).then(function (items) { return items.filter(Boolean); });
    }
    function cartPermalink(items) {
      if (!items.length) return '';
      var pairs = items.map(function (it) { return it.id + ':' + it.quantity; }).join(',');
      var url = window.location.origin + noTrailing(rootUrl()) + '/cart/' + pairs;
      // cupom opcional: o Shopify aplica ?discount= no checkout de quem abre o link
      var couponEl = root.querySelector('[data-wish-coupon]');
      var coupon = couponEl ? couponEl.value.trim() : '';
      if (coupon) url += '?discount=' + encodeURIComponent(coupon);
      return url;
    }
    function addAllToCart() {
      var btn = root.querySelector('[data-wish-add-all]');
      if (btn) btn.disabled = true;
      collectItems().then(function (items) {
        if (!items.length) { if (btn) btn.disabled = false; return; }
        var routes = (window.Shopify && Shopify.routes) || {};
        var addUrl = routes.cart_add_url || (noTrailing(rootUrl()) + '/cart/add');
        var cartUrl = routes.cart_url || (noTrailing(rootUrl()) + '/cart');
        var sectionIds = [];
        document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
          sectionIds.push(el.dataset.sectionId);
        });
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: sectionIds.join(','), sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { if (btn) btn.disabled = false; return; }
            return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: cart, sourceId: 'nv-wishlist', data: { source: 'nv-wishlist', sections: data.sections, itemCount: cart.item_count } }
                }));
                if (btn) btn.disabled = false;
                closeDrawer();
                var drawer = document.querySelector('cart-drawer-component');
                if (drawer && typeof drawer.open === 'function') { drawer.open(); }
              });
          })
          .catch(function (e) { console.error(e); if (btn) btn.disabled = false; });
      });
    }
    function fallbackCopy(text, cb) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.focus(); ta.select();
      try { document.execCommand('copy'); if (cb) cb(); } catch (e) {}
      document.body.removeChild(ta);
    }
    function copyLink() {
      var shareBtn = root.querySelector('[data-wish-copy]');
      var label = root.querySelector('[data-wish-copy-label]');
      collectItems().then(function (items) {
        var url = cartPermalink(items);
        if (!url) return;
        var done = function () {
          if (shareBtn) shareBtn.classList.add('is-copied');
          if (label) {
            var prev = label.getAttribute('data-default') || label.textContent;
            label.setAttribute('data-default', prev);
            label.textContent = 'Link copiado!';
            setTimeout(function () {
              label.textContent = prev;
              if (shareBtn) shareBtn.classList.remove('is-copied');
            }, 2200);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url, done); });
        } else {
          fallbackCopy(url, done);
        }
      });
    }

    function openDrawer() {
      renderList();
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { root.classList.add('nv-wish--open'); });
    }
    function closeDrawer() {
      root.classList.remove('nv-wish--open');
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 300);
    }

    function bindTriggers() {
      document.querySelectorAll('[data-wishlist-toggle]:not([data-wish-bound])').forEach(function (btn) {
        btn.setAttribute('data-wish-bound', '1');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle(btn.getAttribute('data-wishlist-handle'), {
            title: btn.getAttribute('data-wishlist-title'),
            tags: btn.getAttribute('data-wishlist-tags')
          });
        });
      });
      document.querySelectorAll('[data-wishlist-open]:not([data-wish-bound])').forEach(function (btn) {
        btn.setAttribute('data-wish-bound', '1');
        btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
      });
    }

    function init() {
      root = document.getElementById('nv-wishlist');
      if (!root) return;
      customerId = root.getAttribute('data-customer-id') || '';
      listEl = root.querySelector('[data-wish-list]');
      emptyEl = root.querySelector('[data-wish-empty]');
      footEl = root.querySelector('[data-wish-foot]');

      if (!root.dataset.nvBound) {
        root.dataset.nvBound = '1';
        root.querySelectorAll('[data-wish-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
        root.addEventListener('click', function (e) {
          var rm = e.target.closest('[data-wish-remove]');
          if (rm) { toggle(rm.getAttribute('data-wish-remove')); renderList(); }
        });
        var addBtn = root.querySelector('[data-wish-add-all]');
        if (addBtn) addBtn.addEventListener('click', addAllToCart);
        var copyBtn = root.querySelector('[data-wish-copy]');
        if (copyBtn) copyBtn.addEventListener('click', copyLink);
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) closeDrawer(); });

        // The header / cart sections can re-render on cart:update and reset our
        // count badge (it's rendered hidden/"0" by default). Re-assert it.
        document.addEventListener('cart:update', function () {
          updateBadges(); markHearts(); bindTriggers();
          setTimeout(function () { updateBadges(); markHearts(); bindTriggers(); }, 300);
        });
      }

      bindTriggers();

      document.querySelectorAll('.nv-card__video:not([data-nv-vid])').forEach(function (v) {
        v.setAttribute('data-nv-vid', '1');
        var card = v.closest('.nv-card');
        if (!card) return;
        card.addEventListener('mouseenter', function () { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
        card.addEventListener('mouseleave', function () { v.pause(); });
      });

      updateBadges();
      markHearts();
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
